
import { get, post } from '@/utils/requestVideo'

export const resStudyRecordsDianji = p => post('/ResStudyRecords/dianji', p);//浏览量
export const resStudyRecordsXuexi = p => post('/ResStudyRecords/xuexi', p);//学习
export const resStudyRecordsWancheng = p => post('/ResStudyRecords/wancheng', p);//完成